import {
  ListItem,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import { Button } from '@web-app/components/ui/Button/button';
import React, { useEffect, useRef } from 'react';

const FactorReminderModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialFocusRef = useRef<HTMLElement>(null);

  useEffect(() => {
    onOpen();
  }, [onOpen]);

  const handleCompleted = () => {
    onClose();
  };

  return (
    <SessionReminderModal
      popupId="factor-patient-reminders"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent
        ref={initialFocusRef as React.Ref<HTMLElement>}
        tabIndex={-1}
        sx={{ outline: 'none' }}
        bg="bg.default"
        color="text.default"
      >
        <ModalHeader>🥗 Factor Patient Reminders</ModalHeader>

        <ModalBody>
          <UnorderedList spacing={3} pl={2}>
            <ListItem>
              <strong>What is Factor?</strong> A flexible, convenient meal
              delivery service with chef-prepared, dietitian-approved meals—not
              a strict diet plan.
            </ListItem>
            <ListItem>
              Recommend meals and dietary preferences that fit your
              patient&apos;s goals, and remind them to select their weekly
              Factor menu meals.
            </ListItem>
            <ListItem>
              Partnerships are vital to the Berry Street ecosystem — revisit
              Factor orientation{' '}
              <a
                href="https://community.berrystreet.co/c/partnerships/sections/1000529/lessons/3796235"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-legacy underline"
              >
                here
              </a>
              .
            </ListItem>
          </UnorderedList>
        </ModalBody>

        <ModalFooter>
          <div className="flex w-full flex-col gap-2">
            <Button
              onClick={handleCompleted}
              className="w-full bg-primary-legacy text-primary-foreground hover:bg-primary-legacy/90"
            >
              Got it!
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default FactorReminderModal;
